export const LOAD_PROMO = 'promos/LOAD_PROMO'

export const UPDATE_PROMO = 'promos/UPDATE_PROMO'
export const ERROR_PROMO = 'promos/ERROR_PROMO'
export const RESET_PROMO = 'promos/RESET_PROMO'
